const Builder = require('../BuilderBase');

module.exports = class Href extends Builder {
    constructor(title, properties) {
        super('actionElement_Href', title, properties);
    }
};
